var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3536 4.03556C10.5488 3.8403 10.5488 3.52372 10.3536 3.32845L7.17157 0.146473C6.97631 -0.0487893 6.65973 -0.0487893 6.46447 0.146473C6.2692 0.341735 6.2692 0.658318 6.46447 0.85358L9.29289 3.68201L6.46447 6.51043C6.2692 6.7057 6.2692 7.02228 6.46447 7.21754C6.65973 7.4128 6.97631 7.4128 7.17157 7.21754L10.3536 4.03556ZM0 3.68201V4.18201H10V3.68201V3.18201H0V3.68201Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.0138781f8d77d0d4360b77b12f72f49f.svg";
export { ForwardRef as ReactComponent };